module.exports = __webpack_public_path__ + "assets/img/bg-login.93a3f3ef.png";